import React from 'react';
import { Modal } from 'react-bootstrap';
import './HelpDialog.css';
import questionIcon from '../../images/help.svg';

function HelpDialog(props) {
    const { show, handleClose } = props;

    return (
        <Modal show={show} onHide={handleClose} centered dialogClassName="help-modal-dialog">
            <Modal.Header>
                <button type="button" className="close-btn" onClick={handleClose} aria-label="Close">
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="help-modal-body">
            <div className="help-content">
                    <img src={questionIcon} alt="Help Icon" className="help-icon" />
                    <h4 className="help-title">Need help?</h4>
                    <p className="help-text">Contact the Retail Tech Help Desk at:</p>
                    <a href="mailto:rhelpdesk@zadv.com" className="help-email">rhelpdesk@zadv.com</a>
                </div>
            </Modal.Body>       
        </Modal>
    );
}

export default HelpDialog;